<template>
  <span class="offering-status">
    <span class="offering-status__badge" :class="'offering-status__badge--' + state.tone">
      <span v-if="state.tone === 'active'" class="offering-status__pulse" aria-hidden="true"></span>
      {{ state.label }}
    </span>
    <span v-if="showDetail && state.detail" class="offering-status__detail">
      {{ state.detail }}
    </span>
  </span>
</template>

<script>
import { resolveDealState } from "@/utils/offering";

export default {
  name: "OfferingStatusBadge",

  props: {
    // A TokenRequest (possibly carrying a populated `token`) or a Token — resolveDealState
    // works out which of the two holds the live offering state. State and wording resolve in
    // utils/offering.js so every sponsor surface agrees.
    deal: { type: Object, required: true },
    // Countdowns earn their place in a list; inside a page header that already shows the
    // dates they just repeat it.
    showDetail: { type: Boolean, default: true },
  },

  computed: {
    state() {
      return resolveDealState(this.deal);
    },
  },
};
</script>

<style lang="scss" scoped>
$text-muted: #64748b;
$bg-subtle: #f1f5f9;

.offering-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  &__badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;

    &--neutral {
      background: $bg-subtle;
      color: $text-muted;
    }

    &--info {
      background: #e0e7ff;
      color: #4338ca;
    }

    // Open, and taking money.
    &--active {
      background: #dbeafe;
      color: #1d4ed8;
    }

    &--success {
      background: #d1fae5;
      color: #059669;
    }

    &--warning {
      background: #fef3c7;
      color: $warning;
    }

    &--danger {
      background: #fee2e2;
      color: $error;
    }
  }

  &__pulse {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    animation: offering-status-pulse 2s ease-in-out infinite;
  }

  &__detail {
    font-size: 12px;
    color: $text-muted;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@keyframes offering-status-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (prefers-reduced-motion: reduce) {
  .offering-status__pulse {
    animation: none;
  }
}
</style>
